module.exports = __webpack_public_path__ + "img/share_kakao.48424ed1.svg";